import { useState, useEffect } from 'react';
import { getFrameUserContext, FrameContext } from '../services/frameService';

export const useFrameAuth = () => {
  const [frameContext, setFrameContext] = useState<FrameContext>({
    user: null,
    isAuthenticated: false,
    fid: null
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const initializeFrameContext = async () => {
      try {
        setIsLoading(true);
        const context = await getFrameUserContext();
        setFrameContext(context);
        setError(null);
      } catch (err) {
        console.error('Error initializing Frame context:', err);
        setError('Failed to initialize Frame context');
      } finally {
        setIsLoading(false);
      }
    };

    initializeFrameContext();
  }, []);

  return {
    user: frameContext.user,
    isAuthenticated: frameContext.isAuthenticated,
    fid: frameContext.fid,
    isLoading,
    error
  };
}; 